import { axios } from "@/client/libs/axios";

export type SubscriptionResponse = {
  hasActiveSubscription: boolean;
  planType?: "ONE_TIME_DOWNLOAD" | "MONTHLY_SUBSCRIPTION" | null;
  expiresAt?: string | null;
  downloadsUsed?: number;
  downloadsAllowed?: number;
  status?: "active" | "expired";
  paymentId?: string;
  /** Nested subscription when API returns { hasActiveSubscription, subscription, daysRemaining } */
  subscription?: {
    id?: string;
    planType?: string;
    status?: string;
    startsAt?: string;
    expiresAt?: string | null;
    daysRemaining?: number | null;
  } | null;
  daysRemaining?: number;
};

export type CanDownloadResponse = {
  canDownload: boolean;
};

export const subscriptionService = {
  /**
   * Get current subscription status
   */
  getCurrentSubscription: async (): Promise<SubscriptionResponse> => {
    const response = await axios.get<SubscriptionResponse>("/subscriptions/my-subscription");
    return response.data;
  },

  /**
   * Check if user can download a specific resume
   */
  canDownload: async (resumeId: string): Promise<boolean> => {
    const response = await axios.get<CanDownloadResponse>(
      `/subscriptions/can-download/${resumeId}`,
    );
    return response.data.canDownload;
  },
};
